import React from "react";
import Layout from "./components/Layout";
import Header from "./components/Header";
import Store from "./components/Store";

function App() {
  return (
    <Layout>
      <Header />
      <Store />
    </Layout>
  );
}

export default App;
